/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2, breakpoints } from '@coursera/cds-core';

import Subsection from 'bundles/unified-description-page-common/components/shared/Subsection';
import { useMWebStreamlinedXDP } from 'bundles/unified-description-page-common/utils/useStreamlinedXDP';

import _t from 'i18n!nls/xdp';

type Props = { detailItems?: React.ReactNode[] };

const styles = {
  container: css`
    padding: 0 0 var(--cds-spacing-200) 0;
    margin-top: calc(var(--cds-spacing-300) * -1);
    ${breakpoints.down('sm')} {
      margin-top: calc(var(--cds-spacing-100) * -1);
    }
  `,
  item: css`
    margin-top: var(--cds-spacing-200);
    ${breakpoints.down('sm')} {
      margin-top: 0;
    }
  `,
  mWebItem: css`
    display: inline-flex;
    flex-wrap: wrap;
    margin-top: var(--cds-spacing-100);

    // item title
    > div {
      margin-top: calc((var(--cds-spacing-400) + var(--cds-spacing-50)) * -1);
      margin-left: calc((var(--cds-spacing-400) + var(--cds-spacing-50)));
      width: 100%;
    }

    // item description / content
    > div + * {
      margin-top: calc(var(--cds-spacing-100) * -1);
      margin-left: calc((var(--cds-spacing-400) + var(--cds-spacing-50)));
    }
  `,
};

const Details = ({ detailItems }: Props) => {
  const isMWebStreamlinedXDP = useMWebStreamlinedXDP();

  if (!detailItems?.length) {
    return null;
  }

  return (
    <Subsection
      title={
        <Typography2 variant="subtitleLarge" component="h2">
          {_t('Details to know')}
        </Typography2>
      }
      spacing={isMWebStreamlinedXDP ? 12 : 24}
    >
      <Grid container css={styles.container} spacing={16}>
        {detailItems
          .filter((item) => !!item)
          .map((item, index) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <Grid item xs={12} sm={6} md={4} key={index} css={isMWebStreamlinedXDP ? styles.mWebItem : styles.item}>
                {item}
              </Grid>
            );
          })}
      </Grid>
    </Subsection>
  );
};

export default Details;
